<template>
  <div class="pb-3">
    <va-card :title="$t(`club-videos.cards.view`)">
      <div class="row">
        <div class="flex md12">
          <div v-if='video.file.length > 0' class="form-group mt-3">
            <video style="height: 30vh; max-width: 100%;" controls>
              <source :src="$store.getters['environment/cdn'] + '/club-video/' + video.file">
            </video>
          </div>
          <div class="d-flex mt-3">
            <va-button
              type="button"
              class="my-0"
              color="success"
              @click="downloadFile($store.getters['environment/cdn'] + '/club-video/' + video.file, video.file)">
              {{ $t("club-videos.forms.download") }}
            </va-button>
            <va-button
              type="button"
              class="my-0"
              color="danger"
              @click="cancel">
              {{ $t("forms.cancel") }}
            </va-button>
            <va-button
              type="button"
              class="my-0"
              color="danger"
              @click="deletingUpload(video)">
              {{ $t('tooltips.delete') }}
            </va-button>
          </div>
        </div>
      </div>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'sendNotification',
  props: {
    sendData: {
      required: true,
    },
  },
  data () {
    return {
      video: {
        id: '',
        file: '',
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.send'),
    }
  },
  mounted () {
    this.video.id = ''
    this.video.file = ''
    if (this.sendData !== null) {
      this.video_get(this.sendData)
    }
  },
  methods: {
    cancel () {
      this.$emit('close', false)
    },
    video_get (data) {
      Object.keys(data).forEach((value, _) => {
        this.video[value] = data[value]
      })
    },
    deletingUpload (data) {
      const self = this
      this.$axios.delete(
        '/api/upload',
        {
          data: {
            file: data.file,
            path: 'club-video',
          },
        },
      ).then(resp => {
        self.deleting(data)
      })
    },
    deleting (data) {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_club_video_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: data.id,
          },
        })
        .then(_ => {
          this.cancel()
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
    async downloadFile (url) {
      window.open(url, '_blank')
    },
  },
}
</script>
